"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyAdditionalContactsPropsInterface = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var BuyAdditionalContactsPropsInterface = {
  merchandiseId: _propTypes.default.number,
  additionalUnitQuantity: _propTypes.default.number,
  activeTerm: _propTypes.default.string,
  ownsProduct: _propTypes.default.bool,
  trackingSource: _propTypes.default.string,
  onClick: _propTypes.default.func
};
exports.BuyAdditionalContactsPropsInterface = BuyAdditionalContactsPropsInterface;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/additionalContacts/BuyAdditionalContactsPropsInterface.js
// module id = 775
// module chunks = 5 6